import { Dispatch, createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"
import { RootState } from "../reducers"
// import axios from './axios-config';

export interface ChangeResponse {
	message?: string
}

export interface RecoverResponse {
	message?: string
}

interface ChangePayload {
	email: string
	newPassword: string | undefined
	newPasswordConfirmation: string | undefined
	username: string
	token: string | undefined
}

interface RecoverPayload {
	email: string
	username: string
}

export const changePassword = createAsyncThunk<
	ChangeResponse,
	ChangePayload,
	{ rejectValue: string }
>(
	"auth/change",
	async (
		{
			email,
			username,
			newPassword,
			newPasswordConfirmation,
			token,
		}: ChangePayload,
		{ rejectWithValue }
	) => {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}
			const response: AxiosResponse<ChangeResponse> = await axios.post(
				`${process.env.REACT_APP_USER_MANAGEMENT_API_URL}/userservice/apipassword/v2/change`,
				{
					email,
					username,
					newPassword,
					newPasswordConfirmation,
				},
				config
			)
			return response.data
		} catch (error) {
			const axiosError = error as AxiosError<ChangeResponse>
			return rejectWithValue(
				axiosError?.response?.data ?? { message: "error.generic" }
			)
		}
	}
)

export const recoverPassword = createAsyncThunk<
	RecoverResponse,
	RecoverPayload,
	{ rejectValue: string; state?: RootState; dispatch?: Dispatch | undefined }
>(
	"auth/recover",
	async ({ email, username }: RecoverPayload, { rejectWithValue }) => {
		try {
			const response: AxiosResponse<RecoverResponse> = await axios.post(
				`${process.env.REACT_APP_USER_MANAGEMENT_API_URL}/userservice/apipassword/v2/recover`,
				{ email, username }
			)
			return response.data
		} catch (error) {
			const axiosError = error as AxiosError<RecoverResponse>
			return rejectWithValue(
				axiosError?.response?.data ?? { message: "error.generic" }
			)
		}
	}
)
